import { MoveableBookFeature } from './moveable-book-feature';
import { environment } from '../../environments/environment';
import { Loggable } from './loggable';
import { Modalable, ResponseStatus } from './modalable';
import { TechnicalFeature } from '@lemberger/lemberger-am';

export class Video extends MoveableBookFeature implements Loggable, Modalable {
    content: string;
    url: string;
    zIndex = 8;
    logType = TechnicalFeature.Video;
    tool: null;
    bypassCheck = false;
    subtitles: Array<string> | string;
    title: string;

    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getEndpointName(): string {
        return environment.endpointUrls.videos;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }

    getModalId(): string {
        return 'videoModal';
    }
}
